import React, { useState, useEffect  } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import {
  Elements,
} from '@stripe/react-stripe-js';
import { useLocation } from 'react-router'
import { useNavigate } from 'react-router-dom';
import './Winkelwagen.css';

type Props = {}

  const stripePromise = loadStripe("pk_live_51S7F4PGXMXqKTnd0gcu01idzZaEBTVtfpOoB13jf8XJcCooC721b5GlNl2Ohj4HeEX4fh4SzXCsV2QkIKITIarfm00mYdgr3iu");

const Winkelwagen = (props: Props) => {
  const { state } = useLocation();
  const [cart, setCart] = useState(state.cart);
  const [total, setTotal] = useState(state.total);
  const [gekozenLevering, setGekozenLevering] = useState('leveren');
  const [gekozenPersoon, setGekozenPersoon] = useState('alize');
  const navigate = useNavigate();
  const [naam, setNaam] = useState('');
  const [voornaam, setVoornaam] = useState('');
  const [email, setEmail] = useState('');
  const [telefoon, setTelefoon] = useState('');

  const handleChange = (event) => {
    setGekozenLevering(event.target.value);
  };
  const handleChangePerson = (event) => {
    setGekozenPersoon(event.target.value);
  };

  const afrekenen = (e) => {
    e.preventDefault();
    navigate('/afrekenen', {state: {
      total,
      naam: e.currentTarget.elements[0].value,
      voornaam: e.currentTarget.elements[1].value,
      email: e.currentTarget.elements[2].value,
      telefoon: e.currentTarget.elements[3].value,
      opnaamvan: gekozenPersoon === "ander"? e.currentTarget.elements[5].value : gekozenPersoon,
      levermethode: gekozenLevering,
      aantal: cart[0].quantity
    }});
  }

  const minmtn = () => {
    const existingItem = cart.find((cartItem) => cartItem.id === 1);

    if (existingItem.quantity === 1) {
        setCart([]);
    } else {
        setCart(
        cart.map((cartItem) =>
          cartItem.id === 1
            ? { ...cartItem, quantity: cartItem.quantity - 1 }
            : cartItem
        )
      );
    }
  }

  const plusmtn = () => {
        setCart(
        cart.map((cartItem) =>
          cartItem.id === 1
            ? { ...cartItem, quantity: cartItem.quantity + 1 }
            : cartItem
        )
      );
  }

  function handleChangeNaam(e) {
    setNaam(e.target.value);
  }
  
  function handleChangeVoornaam(e) {
    setVoornaam(e.target.value);
  }
  
  function handleChangeEmail(e) {
    setEmail(e.target.value);
  }
  
  function handleChangeTelefoon(e) {
    setTelefoon(e.target.value);
  }

  return (
    <div className="Winkelwagen">
<h2>Bestelling</h2>
<div id="overzicht-bestelling" >
<span id="mtnt-label">Aantal</span>
<span id="aantal">{cart[0].quantity}</span>
<span id="prijsperzak">€{cart[0].price * cart[0].quantity},00</span>
<button onClick={() => minmtn()}>-</button>
<button onClick={() => plusmtn()}>+</button>
</div>
        <form onSubmit={(e) => afrekenen(e)}>
        <p id="prijstotaal">Totaal: €{total},00</p>
<h2>Contactgegevens</h2>
    <p>We gebruiken deze gegevens alleen om contact op te nemen in verband met deze bestelling.</p>
    <div class="formulier">
    <div className="input-container">
      <input type="text" name="lname" value={naam} onChange={handleChangeNaam} required></input>
      <label className={naam && 'filled'}>
        Naam
      </label>
    </div>
    <div className="input-container">
      <input type="text" name="fname" value={voornaam} onChange={handleChangeVoornaam} required></input>
      <label className={voornaam && 'filled'}>
        Voornaam
      </label>
    </div>
    <div className="input-container">
      <input type="text" name="email" value={email} onChange={handleChangeEmail} required></input>
      <label className={email && 'filled'}>
        E-mail
      </label>
    </div>
    <div className="input-container">
      <input type="text" name="phone" value={telefoon} onChange={handleChangeTelefoon} required></input>
      <label className={telefoon && 'filled'}>
        Telefoon
      </label>
    </div>
    </div>

    <h2>Levergegevens</h2>
    <div class="formulier">
      <span>Op naam van:</span>
      <select onChange={handleChangePerson}>
        <option value="alizee">Alizée Segers</option>
        <option value="amber">Amber Ghysels</option>
        <option value="astrid">Astrid Willems</option>
        <option value="charlotte">Charlotte Creemers</option>
        <option value="elise">Elise Veldeman</option>
        <option value="emma">Emma Van der Gucht</option>
        <option value="jessie">Jessie De Bolle</option>
        <option value="lore">Lore De Schutter</option>
        <option value="maithe">Maithé Haus</option>
        <option value="maurane">Maurane Veldeman</option>
        <option value="mel">Mel Van de Velde</option>
        <option value="phoebe">Phoebe De Meulemeester</option>
        <option value="rahissa">Rahissa Penning</option>
        <option value="silke">Silke Limpens</option>
        <option value="tess">Tess Carijn</option>
        <option value="tine">Tine Callebert</option>
        <option value="zara">Zara Janssens</option>
        <option value="ander">Op naam van iemand anders</option>
      </select>

      {gekozenPersoon==="ander"?<input type="text" placeholder="Op naam van" required></input>: null}
      
      <label>
        <input type="radio" name="levering" value="markt" checked={gekozenLevering === 'markt'} onChange={handleChange} />   
        Ophalen op de markt op zaterdag 21/11 tussen 9:30 - 12:30
      </label>
      
      <label>
        <input type="radio" name="levering" value="leveren" checked={gekozenLevering === 'leveren'} onChange={handleChange} />   
        Ik spreek zelf af met mijn contactpersoon (lijst hierboven) voor levering/ophaling
      </label>

</div>
<button>Afrekenen</button>
</form>
    </div>
  );
}

export default Winkelwagen;
